import React, { useEffect, useState } from "react";
import axios from "axios";

const Orders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    axios
      .get("https://zerodha-himans.onrender.com/api/order/all")
      .then((res) => {
        // console.log("Fetched orders:", res.data);
        setOrders(res.data);
      })
      .catch((err) => {
        console.error("Error fetching orders:", err);
      });
  }, []);

  return (
    <div className="order-table">
      <h3 className="title">Order History ({orders.length})</h3>

      <table>
        <thead>
          <tr>
            <th>Stock</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Mode</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(orders) && orders.length > 0 ? (
            orders.map((order, index) => {
              const date = new Date(order.createdAt);
              return (
                <tr key={index}>
                  <td>{order.name}</td>
                  <td>{order.qty}</td>
                  <td>{order.price.toFixed(2)}</td>
                  <td
                    className={order.mode === "BUY" ? "buy-text" : "sell-text"}
                  >
                    {order.mode}
                  </td>
                  <td>{date.toLocaleString()}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="5">No orders found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Orders;
